import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { WeightingContainer } from './shared.sc';

interface Props {
  weighting: number | null;
  locked?: boolean;
}

export const Weighting: FC<Props> = ({ weighting, locked }) => {
  const [t] = useTranslation();
  let weightingStr = t('x.not_available_abbr');
  if (weighting !== null && !isNaN(weighting)) {
    weightingStr = (weighting % 1 === 0 ? weighting : Number(weighting).toFixed(1)) + ' %';
  }

  return (
    <WeightingContainer data-translation="x.okr.weighting">
      {t('x.okr.weighting') + ': ' + weightingStr} {locked ? '\ud83d\udd12' : ''}
    </WeightingContainer>
  );
};
